import Info from "components/view/join/email/info";
import { useTranslation } from "react-i18next";

export default function InfoPage() {
  const { t } = useTranslation();

  return <Info />;
}
